export interface VideoPlayer {
    load(container: HTMLElement, url: string, startPosition: number): Promise<void>;
    getPosition(): Promise<number>;
    pause(): Promise<void>;
    destroy(): void;
    onPlay(cb: () => void): void;
    onPause(cb: () => void): void;
    onEnded(cb: () => void): void;
}

export function detectPlayerType(url: string): 'vimeo' | 'youtube' | 'dailymotion' | 'native' {
    if (/vimeo\.com/i.test(url)) return 'vimeo';
    if (/youtube\.com|youtu\.be/i.test(url)) return 'youtube';
    if (/dailymotion\.com/i.test(url)) return 'dailymotion';
    return 'native';
}
